<template>
  <div class="inspection">
    <div class="nav">
      <div class="nav-left">
        <div
          class="parallelogram-btn-left"
          style="margin-right: 0.5vw"
          @click="backPath"
        >
          <div>返回</div>
        </div>
      </div>
      <div class="nav-center">数据对比</div>
      <div class="nav-right"></div>
    </div>
    <div class="task-content">
      <div class="detail">
        <div class="detail-box">
          <div class="loading-data" v-if="loading" style="margin-top: 15vh">
            <i class="el-icon-loading"></i>
            <div>加载中，请稍后···</div>
          </div>
          <div class="detail-nav">
            <div class="detail-item" style="width: 12.1%">日期</div>
            <div class="detail-item" style="width: 12.1%">时间点</div>
            <div
              class="detail-item"
              style="
                width: 12.1%;
                display: -webkit-flex;
                flex-direction: column;
              "
              v-for="(data, index) in DuoWeiTable"
              :key="index"
            >
              <span class="DBi_duowei" style="display: block">{{
                data.stack
              }}</span>
              <span class="DBi_zuobiao" style="display: block"
                >X:{{ data.X }} Y:{{ data.Y }} Z:{{ data.Z }}</span
              >
              <!-- 氧气 -->
              <span class="DBi_oxy" v-show="nodeType=='01'" style="display: block"> 氧气浓度</span>
                <!-- 二氧化碳 -->
              <span class="DBi_oxy" v-show="nodeType=='02'" style="display: block"> 二氧化碳浓度</span>
                <!-- 温湿度传感器 -->
              <span class="DBi_oxy" v-show="nodeType=='03'" style="display: block"> 温度&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;湿度</span>
                <!-- 包芯温度 -->
              <span class="DBi_oxy" v-show="nodeType=='04'" style="display: block"> 温度</span>
                 <!-- 包芯水分 -->
              <span class="DBi_oxy" v-show="nodeType=='05'" style="display: block"> 水分</span>
            </div>
          </div>
          <div class="detail-content" v-if="!loading">
            <div
              class="detail-list-wrapper" style="justify-content: end;"
              v-if="!loading && tableData.length > 0"
              v-for="(data, index) in tableData[0].day"
              :key="index"
            >
              <div class="detail-item" style="width: 12.1%">
                {{ data }}
              </div>
              <div class="detail-item" style="width: 12.1%">
                {{ tableData[0].time }}
              </div>
              <div
                class="detail-item"
                style="width: 12.1%"
                v-for="(data2, index2) in DuoWeiTable"
                :key="index2"
              >
                <span v-for="(data3, index3) in data2.value"
                :key="index3" >
                 <span v-show="nodeType!='03'" v-if="data3.date == data">{{data3.val}}</span>
                <span v-show="nodeType=='03'" v-if="data3.date == data">{{data3.val}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{data3.val2}}</span>
                </span>
              </div>
            </div>
            <div class="none-data" v-if="!loading && tableData.length < 1">
              暂无数据
            </div>
          </div>
          <div class="page-wrapper" v-if="!loading && total > 9">
            <div class="page-wrapper-left">
              <div>共{{ total }}条数据，当前第{{ page }}页</div>
              <div style="margin-left: 5px">
                <DropDown
                  :content="rowsShow"
                  :items="rowsData"
                  v-on:sendInfo="rowsInfo"
                  class="DropDown"
                ></DropDown>
              </div>
            </div>
            <div class="page-wrapper-right">
              <div class="page-btn" @click="firstPage">首页</div>
              <div class="page-btn" @click="previousPage">上一页</div>
              <div class="page-btn" @click="nextPage">下一页</div>
              <div class="page-btn" @click="lastPage">尾页</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { DataDBiDong } from "../../../api/maintain";
import { renderTime, getDate } from "../../../tools/methods";
export default {
  name: "DueLook",
  data() {
    return {
      // time: ''
      time: [getDate(false), getDate(true)],
      nodeType: "",
      nodeName: "无线氧气传感器",
      tableData: [],
      warehouse: [],
      building: [],
      floor: [],
      area: [],
      stack: [],
      warehouseTitle: "请选择仓库",
      buildingTitle: "请选择楼号",
      floorTitle: "请选择层号",
      areaTitle: "请选择区号",
      stackTitle: "请选择垛位",
      siteId: "",
      siteType: "",
      loading: false,
      all: false,
      page: "1",
      rows: "9",
      total: "",
      rowsShow: "9 条/页",
      rowsData: [
        { name: "9 条/页", value: 7 },
        { name: "20 条/页", value: 20 },
        { name: "100 条/页", value: 100 },
        { name: "200 条/页", value: 200 },
      ],
      idList: [],
      excelData: {},
      storehouseFlag: false,
      contrastList: [],
      contrast1: "请选择对比数据",
      contrast2: "请选择对比数据",
      contrastShowBox: 0,
      contrast1show: 0,
      contrast2show: 0,
      // 养护阶段数据
      maintainStageData: [
        { name: "全部", value: "" },
        { name: "自然醇化阶段", value: "01" },
        { name: "防霉杀虫阶段", value: "02" },
        { name: "气调醇化阶段", value: "03" },
        { name: "气调保质阶段", value: "04" },
      ],
      maintainStage: "",
      CountType: [
        { name: "全部", value: "" },
        { name: "按月", value: "2" },
        { name: "按周", value: "1" },
        { name: "按天", value: "0" },
      ],
      BaoKuoSelect: [
        { name: "不包括", value: "0" },
        { name: "包括", value: "1" },
      ],
      // 选择月/周/天
      SelectConut: "",
      // 选择包括还是不包括
      containVal: "0",
      // 起点
      startTimeData: "",
      // 终点
      endTimeData: "",
      // 氧气浓度上限
      upperVal: "",
      // 氧气浓度下限
      lowerVal: "",
      // 数据对比时间点
      DataDBi: 12,
      DBinodeId: "",
      // 垛位列名
      DuoWeiTable: [],
    };
  },
  created() {
    // let body = this.$route.query.body;
    this.nodeType = this.$route.query.nodeType;
    this.maintainStage = this.$route.query.maintainStage;
    this.time[0] = this.$route.query.startDate;
    this.time[1] = this.$route.query.endDate;
    this.storehouseFlag=this.$route.query.storehouseFlag;
    this.DataDBi = this.$route.query.timeDian;
    console.log(this.$route.query.nodeId);
    this.DBinodeId = this.$route.query.nodeId;
    let _this = this;
    setInterval(function () {
      _this.hide = true;
    }, 100);
    _this.getSeiBeiDetail();
  },
  computed: {
    maintainCountQu: function () {
      return Math.floor(this.statusValue.maintainCount / 4);
    },
  },
  methods: {
    // 格式化时间
    getTime: function (time) {
      return renderTime(time);
    },
    //   获取设备详情列表
    getSeiBeiDetail: function () {
      this.loading = true;
      //   this.hide=false;
      this.tableData = [];
      this.all = false;
      this.idList = [];
      let body = {
        nodeType: this.nodeType,
        maintainStage: this.maintainStage,
        startDate: this.time ? this.time[0] : "",
        endDate: this.time ? this.time[1] : "",
        storehouseFlag:this.storehouseFlag,
        // 数据对比时间点
        time: this.DataDBi,
        nodeId: this.DBinodeId,
      };
      console.log(body);
      DataDBiDong(body)
        .then((res) => {
          this.tableData = res.data.rows;
          this.DuoWeiTable = this.tableData[0].date;
          this.total = res.data.total;
          console.log(this.tableData);
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },
    backPath: function () {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped>
@import "historyData.css";
</style>



// WEBPACK FOOTER //
// src/page/maintain/historyData/DataDBi.vue